import React from "react";
import styled from "styled-components";

export const RightArrow = styled.div`
  cursor: pointer;
`;
export const LeftArrow = styled.div`
  cursor: pointer;
  transform: rotate(180deg);
`;
export const Section = styled.section`
  width: 100%;
  background-color: #fafafa;
  padding: 0 10px;
`;

export const Title = styled.h2`
  font-size: 30px;
  font-weight: 500;
  line-height: 48px;
  margin: 0 auto;
  color: #131945;
  text-align: center;
`;

export const TestimonialsLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1158px;
  margin: 0 auto;
`;

export const TestimonialsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 830px;
  margin: 0 auto;
  padding: 58px 10px 58px;
  overflow: hidden;
`;

export const SlideShow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const HiddenSlidesProvidingHeight = styled(SlideShow)`
  visibility: hidden;
`;

export const InvisibleSlide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  min-width: 100%;
  padding-top: 34px;
  transition: all;
`;

export const VisibleSlide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 34px;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 200ms linear;
`;

export const BlockQuote = styled.blockquote`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 24px;
  line-height: 34px;
  color: #131943;
  letter-spacing: 0;
  text-align: center;
  border: none;
  margin: 0 auto;
  padding: 0;

  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const Quote = ({ children }) => (
  <BlockQuote>&ldquo;{children}&rdquo;</BlockQuote>
);

export const TestimonialName = styled.span`
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0;
  margin-top: 20px;
  color: #576474;
`;

export const VisibleSlides = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
